import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-column-primary" }
const _hoisted_2 = { class: "w-topbar-aux" }
const _hoisted_3 = { class: "w-column-aux" }
const _hoisted_4 = {
  class: "w-topbar-aux-2",
  style: {"font-size":"medium"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-check clickable" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-emoji-angry" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cup-hot clickable" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle clickable" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "interval" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tag" }, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "button-icon-medium" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pen" }, null, -1)
const _hoisted_20 = ["onContextmenu", "onClick"]

import ConsoleComponent from '@/components/lib/ConsoleComponent.vue'
import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import { endeavours as endeavours_get } from '@/controllers/workspaces/user.controller.workspace'
import { nextTick, onBeforeMount, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import TicketSlideup from '@/components/Workspaces/tickets/_spec/TicketSlideUp.vue'
import { useAppContext } from '@/app/_tech';
import GridComponent from '@/app/workspace/components/GridComponent.vue'
import QueueComponent from '@/app/workspace/components/QueueComponent.vue'
import { computed } from '@vue/reactivity';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import sys from '@/sys';
import { TqueuePosition } from '@/logic/_infra/queues';
import { BoardPosition, boards } from '@/logic/_infra/boards';
import { TicketBoardController, TicketQueueController } from '@/components/Workspaces/tickets/_spec/ticket.controller.elementary.interface'
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { Entity } from '@/logic/workspaces/_tech';
import { IEntityRefDto } from '@/io/dto/workspaces/_tech'
import userVueController from '@/components/Workspaces/users/_spec/user.controller.vue'
import * as ticketProcessor from '@/ops/workspaces/ticket.processor'
import * as workspaceProcessor from '@/ops/workspace.processor'
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import { ticketUpdateController_Alt } from '@/controllers/workspaces/tickets/_spec/ticket.controller.chat';
//src\controllers\workspaces\tickets\_model\ticket.item.controller.ts
import { isTicket, isTodo } from '@/controllers/workspaces/tickets/_model/ticket.item.controller'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import AppointmentComponent from '@/components/Workspaces/_spec/AppointmentCreator.vue'
//import {Category} from src\logic\workspaces\persons\_def.ts
import { Category } from '@/logic/workspaces/persons/_def'
import CategoryMenuComponent from '@/app/workspace/project/CategoryMenuComponent.vue'
//import {CategoryOperation} from '@/app/workspace/project/CategoryMenuComponent.types'
import { CategoryOperation } from '@/app/workspace/project/CagegoryMenuComponent.types'
import TimingComponent from '@/components/Workspaces/todos/_spec/TicketTiming.vue'

//src\logic\.infra\boards.ts

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSubview',
  props: {
    workspace: {},
    project: {}
  },
  setup(__props: any) {

const context = useAppContext();

const ticketBoardController = TicketBoardController(context)
const ticketQueueController = TicketQueueController(context)

const props = __props

const project_model = computed(() => context.cursor.project);

watch(() => context.cursor.workspace, setup);

watch(() => props.project, setup);

const { user_level } = userVueController(context)

const model: { ticket_focused: TicketItemModel, ticket_focused_index: number | null, ticket_focused_y: number | null } = reactive({ ticket_focused: new TicketItemModel(), ticket_focused_index: null, ticket_focused_y: null })


const state: { submenu: { category: string | null, category_operation: CategoryOperation }, prompt: { category: boolean } } = reactive({ submenu: { category: null, category_operation: CategoryOperation.Plan }, prompt: { category: false } })



const h =
{
  category: {


    close(){
      
      state.submenu.category = null
    },

    submit() {


      if (context.prompt != undefined) {

        //console.log(value)

        const p = context.cursor.project!

        const w = p.workspace

        const value = context.prompt()

        if (value.length > 0) {

          w.categories.add(value)
          context.storages.workspace!.categoryCreate(w.wid, value, null)
        }
        else sys.warn('empty prompt - no person created')



      }
      else sys.warn('no prompt')
   



    },



    plan_togle(c: string) {

      if (state.submenu.category == c && state.submenu.category_operation == CategoryOperation.Plan) {

        state.submenu.category = null
      }
      else {
        state.submenu.category = c
        state.submenu.category_operation = CategoryOperation.Plan
      }
    },

    plan_setup_aux() {
      state.submenu.category_operation = CategoryOperation.Plan
    },

    report_setup_aux() {
      state.submenu.category_operation = CategoryOperation.Report
    },

    report_togle(c: string) {

      console.log('report' + c)


      if (state.submenu.category == c && state.submenu.category_operation == CategoryOperation.Report) {

        state.submenu.category = null
      }
      else {

        state.submenu.category = c
        state.submenu.category_operation = CategoryOperation.Report
      }
    },

    esc() {
      state.prompt.category = false
    }

  }
}


const endeavours = endeavours_get(context)

onMounted(setup);

function setup() {

  //need to clear focus from peron
  context.cursor.person = null;

  const pid = context.model.projectPid(props.project, props.workspace);

  if (pid != null) {

    if (context.cursor.project === null || context.cursor.project.pid != pid) {

      if (context.cursor.workspace != null) {

        context.cursor.project = context.cursor.workspace.project(pid);


      }
    }
  }
  else context.error(`[THERE-IS-NO-PROJECT:${props.project}]`) //#literal

}

// --- SYSTEM TRIGGERS --- //

const handlers: { handler: globalThis.EventListenerOrEventListenerObject, type: string }[] = [];

onUnmounted(() => {

  handlers.forEach(h => context.triggers.cancel(h)); //usubscribe all evernts by mountd instance
})

onBeforeMount(() => {

  let h;

  h = context.triggers.onCommand((command) => {

    console.log(`Project context - command: ${command}`) //#DEV/TRACING

    const p = context.cursor.project;

    if (p == null) sys.error("Context project is empty")
    else {
      const title = command;

      //context.ops.xbq!.commandSubmit(title, p.workspace.wid, Entity.Project, p.pid)

      workspaceProcessor.commandSubmit(context, title, p.workspace.wid, Entity.Project, p.pid)

    }

  })

  handlers.push(h);
});


function onAdd(position: BoardPosition) {

  const p = context.cursor.project;

  if (p == null) sys.error("Context project is not focused (cursor is empty)") //#error-message
  else {
    //todo parse command like task and etc.
    //const title = command;
    const title = context.ui.consoleContent()

    workspaceProcessor.ticketCreateAndBoard(context, title, p, position)


    context.ui.consoleContentClear()
  }
}

function onSwipeUp(position: { x: number, y: number }) {

  //probably swipes are internal grid operations? it actually should post changes in grid itslef
}
function onSwipDown(position: { x: number, y: number }) {

}

function onGridDrop(ref: IEntityRefDto, position: BoardPosition) {

  const p = context.cursor.project!

  if (ref.type == null) {

    const ticket = p.workspace.ticket(ref.n)

    const target = boards.itemOrNull(p.disposition.board, position)

    if (target != null) {

      sys.warn('Swap operation is not impemented')
    }
    else {
      context.ops.xbq!.board(ticket, p, position)
    }


  }
  else sys.warn(`/workspaces/project - Todo item has no sense in project context. N:${ref.n}`)



}



function onPendingQueueDrop(ref: IEntityRefDto, position: number) { queue(ref, new TqueuePosition('queue', position)) }

function onPinnedQueueDrop(ref: IEntityRefDto, position: number) { queue(ref, new TqueuePosition('pins', position)) }

function queue(ref: IEntityRefDto, position: TqueuePosition) {

  const p = context.cursor.project!

  if (ref.type == null) {

    const ticket = p.workspace.ticket(ref.n)

    //const target = boards.itemOrNull(p.disposition.board, position)

    context.ops.xbq!.queue(ticket, p, position)
  }
  else sys.warn(`/workspaces/project - Todo item has no sense in project context. N:${ref.n}`)
}

function isCurrentSlideup(t: TicketRmodel | TodoRmodel) {

  if (isTicket(t)) return (model.ticket_focused.ticket?.n == t.n)

  else if (isTodo(t)) return (model.ticket_focused.ticket?.n == t.ticket.n)

  else throw Error('Unknow type')
}


function resetSlideup() {
  model.ticket_focused.disposeIf()
  model.ticket_focused_index = null
  model.ticket_focused_y = null

}

function ticketPopup_Queue(t: TicketRmodel | TodoRmodel, level: number) {

  if (isCurrentSlideup(t)) return resetSlideup()


  const element_board = document.getElementById('board') as HTMLElement

  if (element_board) {
    const level_board = element_board.offsetTop

    const level_relative = level - level_board

    const elements_rows = Array.from(element_board.children).filter(x => x.classList.contains('row'))

    let s: number = -1

    elements_rows.forEach(v => s += v.clientHeight)

    let index = -1;

    if (isTicket(t)) {
      model.ticket_focused.set(t, context)
    }


    if (level_relative < 0) {

      //#dev console.log(`Found index: ${index}`)

      model.ticket_focused_index = 0;
      model.ticket_focused_y = null
    }
    else {

      let height_accumulating = 0;

      for (let i = 0; i < elements_rows.length; i++) {

        const element = elements_rows[i];

        const h = element.getBoundingClientRect().height

        height_accumulating += h;

        if (level_relative < height_accumulating) {

          index = i;

          //#dev console.log(`Found index: ${index}`)

          model.ticket_focused_index = index;
          model.ticket_focused_y = null
          break;
        }
      }

      if (index < 0) {

        model.ticket_focused_index = null;
        model.ticket_focused_y = level_relative - height_accumulating

        //#dev console.log(`Overflow. Offset: ${model.ticket_focused_y}`)
      }
    }
  }
  else sys.warn("Can't find 'board' element by id")
}

function ticketPopup(t: TicketRmodel | TodoRmodel) {

  if (t instanceof TicketRmodel && project_model.value != null) {

    if (!isCurrentSlideup(t)) {

      const p = boards.positionOrNull(project_model.value.disposition.board, t)

      if (p != null) {

        model.ticket_focused.set(t, context)

        model.ticket_focused_index = p.row + 1

      }
      else sys.info('Ticket details')
    }
    else resetSlideup()
  }
}

function onTicketCommand(command: string, t: TicketRmodel) {

  ticketProcessor.commandSubmitOnTicket2(context, command, t)
}


ticketUpdateController_Alt(context, model.ticket_focused)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(project_model) != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(UserEdeavoursControl, {
                items: _unref(endeavours),
                class: "endeavours"
              }, null, 8, ["items"])
            ]),
            _createVNode(GridComponent, {
              class: "grid",
              id: "board",
              matrix: _unref(project_model).disposition.board,
              controller: _unref(ticketBoardController),
              level: _unref(user_level),
              focused: model.ticket_focused,
              focused_index: model.ticket_focused_index,
              files: _unref(context).storages.files,
              onAdd: onAdd,
              onDrop: onGridDrop,
              efforts: _unref(context).userEfforts() ?? undefined,
              onClick: ticketPopup,
              onCommand: onTicketCommand,
              onPopupClosed: _cache[0] || (_cache[0] = () => { model.ticket_focused.clear(); model.ticket_focused_index = null })
            }, null, 8, ["matrix", "controller", "level", "focused", "focused_index", "files", "efforts"]),
            (model.ticket_focused_y != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle([{"position":"relative"}, { top: model.ticket_focused_y + 'px' }])
                }, [
                  _createVNode(TicketSlideup, {
                    model: model.ticket_focused,
                    files: _unref(context).storages.files,
                    level: _unref(user_level),
                    onClose: _cache[1] || (_cache[1] = () => model.ticket_focused_y = null)
                  }, null, 8, ["model", "files", "level"])
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).P.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).P.toString() }, "button-icon-medium"])
              }, _hoisted_6, 2),
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).L.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).L.toString() }, "button-icon-medium"])
              }, _hoisted_8, 2),
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).I.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).I.toString() }, "button-icon-medium"])
              }, _hoisted_10, 2),
              _createElementVNode("span", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).X.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).X.toString() }, "button-icon-medium"])
              }, _hoisted_12, 2),
              _hoisted_13,
              _createElementVNode("span", {
                class: "button-icon-medium",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (h.category.submit()), ["stop"]))
              }, _hoisted_16),
              _hoisted_17,
              (state.submenu.category == _unref(Category).P.toString())
                ? (_openBlock(), _createBlock(TimingComponent, {
                    key: 0,
                    class: "report-menu-special",
                    category: _unref(Category).P.toString(),
                    efforts: _unref(context).userEfforts() ?? undefined
                  }, null, 8, ["category", "efforts"]))
                : _createCommentVNode("", true),
              (state.submenu.category == _unref(Category).L.toString())
                ? (_openBlock(), _createBlock(TimingComponent, {
                    key: 1,
                    class: "report-menu-special",
                    category: _unref(Category).L.toString(),
                    efforts: _unref(context).userEfforts() ?? undefined
                  }, null, 8, ["category", "efforts"]))
                : _createCommentVNode("", true),
              (state.submenu.category == _unref(Category).I.toString())
                ? (_openBlock(), _createBlock(TimingComponent, {
                    key: 2,
                    class: "report-menu-special",
                    category: _unref(Category).I.toString(),
                    efforts: _unref(context).userEfforts() ?? undefined
                  }, null, 8, ["category", "efforts"]))
                : _createCommentVNode("", true),
              (state.submenu.category == _unref(Category).X.toString())
                ? (_openBlock(), _createBlock(TimingComponent, {
                    key: 3,
                    class: "report-menu-special",
                    category: _unref(Category).X.toString(),
                    efforts: _unref(context).userEfforts() ?? undefined
                  }, null, 8, ["category", "efforts"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                onContextmenu: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).M.toString())), ["right","stop","prevent"])),
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (h.category.plan_togle(_unref(Category).M.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).M.toString() }, "button-category"])
              }, [
                _hoisted_18,
                _createTextVNode(" Meeting")
              ], 34),
              (state.submenu.category == _unref(Category).M.toString())
                ? (_openBlock(), _createBlock(CategoryMenuComponent, {
                    key: 0,
                    category: _unref(Category).M.toString(),
                    operation: state.submenu.category_operation,
                    "onUpdate:operation": _cache[9] || (_cache[9] = ($event: any) => ((state.submenu.category_operation) = $event)),
                    project_model: _unref(project_model),
                    onSubmit: _cache[10] || (_cache[10] = ($event: any) => (h.category.close())),
                    onCancel: _cache[11] || (_cache[11] = ($event: any) => (h.category.close()))
                  }, null, 8, ["category", "operation", "project_model"]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onContextmenu: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (h.category.report_togle(_unref(Category).N.toString())), ["right","stop","prevent"])),
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (h.category.plan_togle(_unref(Category).N.toString())), ["left","stop"])),
                class: _normalizeClass([{ 'menu-button-active': state.submenu.category == _unref(Category).N.toString() }, "button-category"])
              }, [
                _hoisted_19,
                _createTextVNode(" Notice")
              ], 34),
              (state.submenu.category == _unref(Category).N.toString())
                ? (_openBlock(), _createBlock(CategoryMenuComponent, {
                    key: 1,
                    category: _unref(Category).N.toString(),
                    operation: state.submenu.category_operation,
                    "onUpdate:operation": _cache[14] || (_cache[14] = ($event: any) => ((state.submenu.category_operation) = $event)),
                    project_model: _unref(project_model),
                    onSubmit: _cache[15] || (_cache[15] = ($event: any) => (h.category.close())),
                    onCancel: _cache[16] || (_cache[16] = ($event: any) => (h.category.close()))
                  }, null, 8, ["category", "operation", "project_model"]))
                : _createCommentVNode("", true),
              (_unref(context).cursor.workspace != null)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(context).cursor.workspace.categories, (c) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: c }, [
                      _createElementVNode("button", {
                        class: _normalizeClass([{ 'menu-button-active': state.submenu.category == c }, "button-category"]),
                        onContextmenu: _withModifiers(($event: any) => (h.category.report_togle(c)), ["right","stop","prevent"]),
                        onClick: _withModifiers(($event: any) => (h.category.plan_togle(c)), ["left","stop"])
                      }, _toDisplayString(c), 43, _hoisted_20),
                      (state.submenu.category == c)
                        ? (_openBlock(), _createBlock(CategoryMenuComponent, {
                            key: 0,
                            category: c,
                            operation: state.submenu.category_operation,
                            "onUpdate:operation": _cache[17] || (_cache[17] = ($event: any) => ((state.submenu.category_operation) = $event)),
                            project_model: _unref(project_model),
                            onSubmit: _cache[18] || (_cache[18] = ($event: any) => (h.category.close())),
                            onCancel: _cache[19] || (_cache[19] = ($event: any) => (h.category.close()))
                          }, null, 8, ["category", "operation", "project_model"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true),
              (_unref(context).cursor.workspace?.user_person != null)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(context).cursor.workspace.user_person.categories, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: "button-category",
                      key: c
                    }, _toDisplayString(c), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", null, null, 512), [
              [_vShow, state.prompt.category]
            ]),
            _createVNode(QueueComponent, {
              class: "w-subqueue",
              tickets: _unref(project_model).disposition.queue,
              controller: _unref(ticketQueueController),
              onDrop: onPendingQueueDrop,
              onClickStrip: ticketPopup_Queue,
              onCommand: onTicketCommand,
              level: _unref(user_level),
              files: _unref(context).storages.files,
              efforts: _unref(context).userEfforts() ?? undefined
            }, null, 8, ["tickets", "controller", "level", "files", "efforts"]),
            _createVNode(QueueComponent, {
              class: "w-subqueue",
              tickets: _unref(project_model).disposition.pins,
              controller: _unref(ticketQueueController),
              onDrop: onPinnedQueueDrop,
              onCommand: onTicketCommand,
              level: _unref(user_level),
              onClickStrip: ticketPopup_Queue,
              files: _unref(context).storages.files,
              efforts: _unref(context).userEfforts() ?? undefined
            }, null, 8, ["tickets", "controller", "level", "files", "efforts"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})